import MediaCard from './common/MediaCard'

const WhatIsMailForwarding = () => {
    return (
        <MediaCard
            layout={{
                desktop: 'content-right-media-left',
                mobile: 'media-top-content-bottom',
            }}
            imageContainerWidth='45%'
            imageFitPreset='cover-right'
            image={{
                alt: 'Robot arm with mail zoomed',
                desktop: {
                    src: '/images/new/robot-arm-mail-zoomed-v2.png',
                    dimensions: { width: 616, height: 1005 },
                },
                mobile: {
                    src: '/images/new/robot-arm-mail.png',
                    dimensions: { width: 696, height: 1122 },
                },
            }}
        >
            <div className='d-flex flex-1 flex-column gap-lg-4 gap-2 px-4 pb-8 mt-n6 mt-lg-0 pe-lg-18 py-lg-26 mt-lg-0 mt-n16 ms-lg-n20'>
                <h2 className='fw-semibold lh-105 mb-1 fs-fluid-36-52'>
                    What is mail <span className='color-pink2'>forwarding</span>.
                </h2>
                <span className='fw-semibold lh-132 fs-fluid-18-22'>
                    With our comprehensive service we receive your physical mail, scan it
                    and digitise it. Once that is complete you have the option to have the
                    physical copies mailed to you. We have multiple options for you to get
                    hold of the physical copies of your mail ensuring ultimately
                    flexibility around your business mail. Ultimately, you decide how you
                    want to get your mail, including having it sent directly to your
                    account address.
                </span>
            </div>
        </MediaCard>
    )
}

export default WhatIsMailForwarding
